import React, { FC } from 'react'
import { Box, Text } from '@moonpig/launchpad-components'
import { ModuleContext, ModuleSimplifiedHeading } from '../../types'
import { useLocaleText } from '../locale'

type Props = {
  module: ModuleSimplifiedHeading
  context: ModuleContext
}

export const SimplifiedHeadingModule: FC<Props> = () => {
  const localiseText = useLocaleText()

  const getHeading = () => {
    return (
      <Box>
        <Text
          as="h2"
          color={'colorTextHeadline'}
          typography={{ xs: 'typeMobileDisplay05', md: 'typeDesktopDisplay06' }}
        >
          {localiseText('heading.price')}
        </Text>
      </Box>
    )
  }
  return <Box data-testid="module-simplified-heading">{getHeading()}</Box>
}
